module.exports = __webpack_public_path__ + "assets/montserrat-bold.5a95e90216c2970b45067e11c3600bae.woff2";